/* Displays a list of locations */
/* -------------------------------------------------------------------------------------- */
function renderLocations(dataLocations, distance) {
	$('#list-locations').empty();
	for (var i = 0; i < dataLocations.length; i++) {
		let iAddress = dataLocations[i].address;
		let regex = /[^\s]/;
		let iAddressCondicion = regex.test(dataLocations[i].distance);
		let iDistanceCondicion = (iAddressCondicion == true) ? dataLocations[i].distance : '0 km';
		let iDistance = (distance == true) ? '<p class="cart__method-list-item-distancia">Distancia: '+ iDistanceCondicion +'</p>': '';
		let iName = dataLocations[i].name;
		let templateLocartion = '<div class="cart__method-list-item">' +
									'<div>' +
										'<h5 class="mt-p0 mb-p0">'+ iName +'</h5>' +
										'<div>' +
											'<p>'+ iAddress +'</p>' +
											iDistance +
										'</div>' +
									'</div>' +
									'<div>' +
										'<a href="#" class="button button--small" js-select-location data-name="'+ iName +'" data-address="'+iAddress+'">Seleccionar</a>' +
									'</div>'+
								'</div>';
		$('#list-locations').append(templateLocartion);
	}
}
/* Get a list of stores by location */
/* -------------------------------------------------------------------------------------- */
function fetchLocationsbyDistace(dataLat, dataLng) {
	$.ajax({
		type: "POST",
		url: "https://stihlenlinea.cemcol.com/api/distance",
		headers: {
			Authorization: "Token 9cbad76f0805d793fa98e9c252853477d3c3fb84",
		},
		data: {
			latitude: dataLat,
			longitude: dataLng,
		},
		dataType: "json",
		success: function (response) {
			let dataLocations = response.locations;
			renderLocations(dataLocations, true);
		},
		error: function (e, t) {
		},
	});
}
/* Get list of stores */
/* -------------------------------------------------------------------------------------- */
function fetchLocations() {
	$.ajax({
		type: "GET",
		url: "https://stihlenlinea.cemcol.com/api/locations",
		headers: {
			Authorization: "Token 9cbad76f0805d793fa98e9c252853477d3c3fb84",
		},
		dataType: "json",
		success: function (response) {
			let dataLocations = response.locations;
			renderLocations(dataLocations, false);
		},
		error: function (e, t) {
			return 0;
		},
	});
}
/* Update cart with note */
/* -------------------------------------------------------------------------------------- */
function updateNoteCart() {
	let regex = /[^\s]/;
	let iNote = $('[js-cart-add-note]').val();
	let iNoteCliente = $('[js-cart-add-note-client]').val();
	let inputCondicion = regex.test(iNoteCliente);
	let iNoteClienteFormat = inputCondicion ? '\nNOTAS ADICIONALES\n'+iNoteCliente : '';
	/* Concatenation of note fields */
	let dataInput = iNote + iNoteClienteFormat;

	$.ajax({
		type: 'POST',
		url: '/cart/update',
		data: {
			note: dataInput
		},
		dataType: 'json',           
		success: function() {
		},
		error: function() {
		}
	});
}
/* Pop-up: Select method */
/* -------------------------------------------------------------------------------------- */
$('#choose-search').on('change', function(event) {
	event.preventDefault();
	/* Act on the event */
	var $option = $(this).find('option:selected');
	var value = $option.val();
	if(value == 'ubicacion') {
		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(function(position){
				$.get( "http://maps.googleapis.com/maps/api/geocode/json?latlng="+ position.coords.latitude + "," + position.coords.longitude +"&sensor=false&key=AIzaSyCV6iB_vR7hUv6Tj7U5UnBaSGhE3zfGDQg", function(data) {
					let data_results = data.results;
					$('#list-address').empty();
					/* List address */
					for (var i = 0; i < data_results.length; i++) {
						let iAddress = data_results[i].formatted_address;
						let iLat = data_results[i].geometry.location.lat;
						let ilng = data_results[i].geometry.location.lng;
						let templateAddress = '<div class="cart__list-address-item" js-list-address-item data-lat="'+iLat+'" data-lng="'+ilng+'">'+
													iAddress +
												'</div>';
						$('#list-address').append(templateAddress);
					}
					$('#list-address').addClass('active');
				})
			});
		}
	}
	if (value == 'manual') {
		$('input[id=address]').val(' ');
		$('#list-address').removeClass('active');
		fetchLocations();
	}
});
/* Pop-up: Address of list */
/* -------------------------------------------------------------------------------------- */
$('.field--group-list').on('click', '[js-list-address-item]', function(event) {
	event.preventDefault();
	/* Act on the event */
	let el = $(this);
	let dataLat = el.attr('data-lat');
	let dataLng = el.attr('data-lng');
	fetchLocationsbyDistace(dataLat, dataLng);
	el.closest('#list-address').removeClass('active');
	$('input[id=address]').val(el.text());
});
/* Pop-up: Focus input */
/* -------------------------------------------------------------------------------------- */
$('input[id=address]').on('focus', function(event) {
	event.preventDefault();
	/* Act on the event */
	var $option = $('#choose-search').find('option:selected');
	var value = $option.val();
	if(value == 'ubicacion') {
		$('#list-address').addClass('active');
	}else{
		$('#list-address').removeClass('active');
	}
});
/* Pop-up: Select location */
/* -------------------------------------------------------------------------------------- */
$('.cart__method').on('click', '[js-select-location]', function(event) {
	event.preventDefault();
	/* Act on the event */
	let el = $(this);
	let iName = el.attr('data-name');
	let iAddress = el.attr('data-address');
	let location = 'SUCURSAL SELECCIONADA\nTienda: '+iName+'\nDirección: '+iAddress;
	/* Set location in note */
	$('[js-cart-add-note]').attr('disabled', false);
	$('[js-cart-add-note]').val(location);
	$('[js-cart-add-note]').attr('disabled', true);
	/* Close pop-up */
	$('#method-pickup-chose').removeClass('active');
	$('#MainContent').css('z-index', '1');
	/* Send value to cart */
	updateNoteCart();
	/* Enabled checkout */
	$('[name=checkout]').each(function(index, el) {
		$(el).removeClass('button--disabled');
		$(el).removeAttr('disabled');
	});	
	$('.cart__checkout-message').each(function(index, el) {
		$(el).removeClass('active');
	});	
});
/* Select Delivery */
/* -------------------------------------------------------------------------------------- */
$('.cart__method').on('click', '#method-delivery', function(event) {
	event.preventDefault();
	/* Act on the event */
	let el = $(this),
		item = $(el.attr('data-open'));
	if (!el.hasClass('disable')) {
		$('[js-cart-add-note]').closest('.cart__note-location').removeClass('active');
		$('[js-cart-add-note]').val('');
		updateNoteCart();
		el.addClass('active');
		el.siblings('#method-pickup').removeClass('active');
		var regex = /[^\s]/;
		var inputValue = $('[js-cart-add-note]').val();
		var inputCondicion = regex.test(inputValue);
		if(inputCondicion){
			item.addClass('active');
		}
	}
	/* Enabled checkout */
	$('[name=checkout]').each(function(index, el) {
		$(el).removeClass('button--disabled');
		$(el).removeAttr('disabled');
	});	
	$('.cart__checkout-message').each(function(index, el) {
		$(el).removeClass('active');
	});	
});
/* Select Pickup */
/* -------------------------------------------------------------------------------------- */
$('.cart__method').on('click', '#method-pickup', function(event) {
	event.preventDefault();
	/* Act on the event */
	let el = $(this),
		item = $(el.attr('data-open'));
	el.addClass('active');
	item.addClass('active');
	el.siblings('#method-delivery').removeClass('active');
	$('#MainContent').css('z-index', '10');
	$('[js-cart-add-note]').closest('.cart__note-location').addClass('active');
	/* Act on the event */
	var $option = $('#choose-search').find('option:selected');
	var value = $option.val();
	if(value == 'ubicacion') {
		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(function(position){
				$.get( "http://maps.googleapis.com/maps/api/geocode/json?latlng="+ position.coords.latitude + "," + position.coords.longitude +"&sensor=false&key=AIzaSyCV6iB_vR7hUv6Tj7U5UnBaSGhE3zfGDQg", function(data) {
					let data_results = data.results;
					$('#list-address').empty();
					for (var i = 0; i < data_results.length; i++) {
						let iAddress = data_results[i].formatted_address;
						let iLat = data_results[i].geometry.location.lat;
						let ilng = data_results[i].geometry.location.lng;
						let templateAddress = '<div class="cart__list-address-item" js-list-address-item data-lat="'+iLat+'" data-lng="'+ilng+'">'+
													iAddress +
												'</div>';
						$('#list-address').append(templateAddress);
					}
					$('#list-address').addClass('active');
				})
			});
		}
	}else if(value == 'manual'){
		$('input[id=address]').val(' ');
		$('#list-address').removeClass('active');
		fetchLocations();
	}
	/* Disabled checkout */
	$('[name=checkout]').each(function(index, el) {
		$(el).addClass('button--disabled');
		$(el).attr('disabled');
	});
	$('.cart__checkout-message').each(function(index, el) {
		$(el).addClass('active');
	});
});
/* Add note to cart */
/* -------------------------------------------------------------------------------------- */
$('.carts-footer').on('keydown', '[js-cart-add-note-client]', debounce(function(){
	updateNoteCart();
},500));
/* Add note to cart */
/* -------------------------------------------------------------------------------------- */
$('[name=checkout]').each(function(index, el) {
	var regex = /[^\s]/;
	var inputValue = $('[js-cart-add-note]').val();
	var inputCondicion = regex.test(inputValue);
	if(inputCondicion == false  && $('#method-delivery').hasClass('disable')){
		$(el).addClass('button--disabled');
		$(el).attr('disabled');
	}else{
		$(el).removeClass('button--disabled');
		$(el).removeAttr('disabled');
	}
});	
$('.cart__checkout-message').each(function(index, el) {
	var regex = /[^\s]/;
	var inputValue = $('[js-cart-add-note]').val();
	var inputCondicion = regex.test(inputValue);
	if(inputCondicion == false && $('#method-delivery').hasClass('disable')){
		$(el).addClass('active');
	}else{
		$(el).removeClass('active');
	}
});
$('body').on('click', '[js-close-item-choose]', function(event) {
	event.preventDefault();
	/* Act on the event */
	var el = $(this),
		item = $(el.attr('data-close'));
	item.removeClass('active');
	$('#MainContent').css('z-index', '1');
});